import React, { Component } from 'react';
import {Link} from 'react-router';
import {firebaseApp} from '../../utils/firebase';

class DropDownMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAdmin: false,
            isTracker: false,
        };

        this.checkState = this.checkState.bind(this);
    }

    componentDidMount() {
        this.checkState();
    }

    adminLinks() {
        return [
            <li key="separatorAdmin" role="separator" className="divider"/>,
            <li key="editCars"><Link to="/edit-cars">Upraviť vozidla</Link></li>,
            <li key="adminFuelTracker"><Link to="/admin-fuel-tracker">Admin Záznam paliva</Link></li>,
            <li key="usersListing"><Link to="/users-listing">Použivatelia</Link></li>,
        ];
    }

    isTrackerLinks() {
        return [
            <li key="separatorIsTracker" role="separator" className="divider"/>,
            <li key="fuelTracker"><Link to="/fuel-tracker">Záznam paliva</Link></li>,
        ];

    }

    checkState() {
        firebaseApp.database().ref('/users/' + this.props.uid + '/admin').once('value', snap => {
            if (snap.val() === true)
                this.setState({ isAdmin: true });

        }, (error) => {
            console.error("Firebase ERROR");
            console.error(error);
        });

        firebaseApp.database().ref('/users/' + this.props.uid + '/isTracker').once('value', snap => {
            if (snap.val() === true)
                this.setState({isTracker: true});

        }, (error) => {
            console.error("Firebase ERROR");
            console.error(error);
        });
    }

    render() {
        return (
            <ul className="dropdown-menu">
                <li><Link to="/driver-profile">Moje údaje</Link></li>
                <li><Link to="/profile">Zmeniť heslo</Link></li>

                {this.state.isTracker && this.isTrackerLinks()}

                {this.state.isAdmin && this.adminLinks()}

                <li role="separator" className="divider" />
                <li><Link to="/logout" onClick={this.props.logOut}>Odhlásiť</Link></li>
            </ul>
        );
    }
}

export default DropDownMenu;


// WEBPACK FOOTER //
// ./src/app/components/user/dropDownMenu.js